class BaseResponse{
  response(){
    return{
      responseCode:null,
      responseMessage:null
    };
  }
}

export default BaseResponse;